module.exports = __webpack_public_path__ + "img/data-footer.5e2723d7.png";